import { render, staticRenderFns } from "./AddModule.vue?vue&type=template&id=5089dd5a&scoped=true&"
import script from "./AddModule.vue?vue&type=script&lang=js&"
export * from "./AddModule.vue?vue&type=script&lang=js&"
import style0 from "./AddModule.vue?vue&type=style&index=0&id=5089dd5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089dd5a",
  null
  
)

export default component.exports